export type ServerSessionRecoveryOptions = {
  isOnline: boolean;
  isReplayRequest: boolean;
};

/**
 * Only an online 401 from the incident replay route recovers the server session.
 * This is the FR-002 fresh-auth-before-replay gate: a queued write must never
 * replay with a stale credential. Offline requests never force a logout (FR-001).
 *
 * NOTE: the live inactivity control is `useInactivityLogout` in auth.provider,
 * which is DOM-activity based, parent-shell only, and intentionally disabled when
 * `offlineSessionEnabled` (so an offline-capable app never force-logs-out). The
 * request-interceptor inactivity branch that referenced this helper was redundant
 * dead code and has been removed.
 *
 * REVISIT-LATER (deferred 2026-07-17, review option b):
 *  1. Whether an offline-capable app should have any inactivity control at all
 *     while online (today `useInactivityLogout` skips it entirely when offline
 *     sessions are enabled).
 *  2. Whether a non-replay online 401 should force re-authentication — currently
 *     it does not, which is deliberate so offline-first capture is never
 *     interrupted, but it means a server-side token revocation is not surfaced
 *     until the next replay.
 */
export const shouldRecoverServerSession = ({
  isOnline,
  isReplayRequest,
}: ServerSessionRecoveryOptions) => isOnline && isReplayRequest;
